<template>
  <div>
    <v-card :to="item.to" height="100%" class="property-card" tile flat>
      <div class="relative property-img">
        <img :src="item.img" v-if="item.img" class="d-block" />

        <v-sheet
          class="
            d-flex
            align-center
            secondary
            white--text
            text-h6
            foint-weight-medium
            px-2
            property-business
          "
          height="22px"
          v-if="item.business"
        >
          {{ item.business }}
        </v-sheet>
      </div>

      <div class="px-4 py-3 caption">
        <div
          class="primary--text text-h6 text-md-h5 font-weight-medium mb-1"
          v-if="item.title"
        >
          {{ item.title }}
        </div>

        <div class="primary--text text-h6 font-weight-regular" v-if="item.ref">
          REF: {{ item.ref }}
        </div>
        <div
          class="primary--text text-h6 font-weight-regular"
          v-if="item.district"
        >
          {{ item.district }}
        </div>

        <div
          class="
            accent--text
            text-h5 text-md-h4 text-lg-h3
            font-weight-bold
            mt-2
          "
          v-if="item.price"
        >
          {{ item.price }}
        </div>

        <v-divider class="my-2" v-if="details.length" />

        <div class="d-flex align-center justify-space-around">
          <div
            class="d-flex align-center"
            v-for="({ icon, num, text }, key) in details"
            :key="key"
          >
            <v-icon color="secondary" size="16" class="mr-2">
              {{ icon }}
            </v-icon>
            <span class="primary--text text-h6 font-weight-regular">
              {{ num + (!sm && text ? text : ``) }}
            </span>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    details: [],
  }),
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.details = [];

    if (this.item.garage)
      this.details.push({
        icon: "fas fa-car",
        num: this.item.garage,
        text: this.item.garage > 1 ? ` Vagas` : ` Vaga`,
      });
    if (this.item.bedrooms)
      this.details.push({
        icon: "fas fa-bed",
        num: this.item.bedrooms,
        text: this.item.bedrooms > 1 ? ` Quartos` : ` Quarto`,
      });
  },
};
</script>

<style lang="scss" scoped>
.property-card {
  box-shadow: 0px 1px 2px rgba(57, 60, 64, 0.24) !important;
  border-radius: 4px !important;
  transition: all 0.1s linear;
  .property-img {
    img {
      aspect-ratio: 270 / 220;
      border-radius: 4px 4px 0 0 !important;
      object-fit: cover;
      -o-object-fit: cover;
      object-position: center;
      -o-object-position: center;
      transition: all 0.1s linear;
      width: 100%;
    }
    .property-business {
      bottom: 0;
      border-radius: 4px 0 0 0;
      position: absolute;
      right: 0;
    }
  }
  &:hover {
    box-shadow: 0px 2px 4px rgba(57, 60, 64, 0.15),
      0px 4px 8px rgba(57, 60, 64, 0.24) !important;
  }
}
</style>
